import jenniferGameDialogDataset from "../dialogDatasets/jennifer_game_dialog_dataset";
import charlieGameDialogDataset from "../dialogDatasets/charlie_game_dialog_dataset";
import cindyGameDialogDataset from "../dialogDatasets/cindy_game_dialog_dataset";
import cameronGameDialogDataset from "../dialogDatasets/cameron_game_dialog_dataset";
import { checkDialogConditions } from "./check_dialog_conditions";

export const retrieveGameDialog = (friendName, lastIndx, playerConditions) => {
    let dialogTable = [];
    let selectDialog = false;
    let returnDialogObj = "";  
    let dialogPlayerConditions = JSON.parse(JSON.stringify(playerConditions));
 
    switch (friendName){
        case "Jennifer":
            dialogTable = jenniferGameDialogDataset.dialogTable;
            break;
        case "Charlie":
            dialogTable = charlieGameDialogDataset.dialogTable;
            break;
        case "Cindy":
            dialogTable = cindyGameDialogDataset.dialogTable;
            break;
        case "Cameron":
            dialogTable = cameronGameDialogDataset.dialogTable;
            break;
        default:
            break;
    }
    if (lastIndx === "firstTime"){
        lastIndx = 0;
    }else{
        lastIndx = +lastIndx + 1;
    }
    let nbrDialogItems = dialogTable.length
    if (lastIndx > nbrDialogItems - 1){
         // start dialog again but start at 1 to skip over intro dialog item
          lastIndx = 1;
    }
    let dialogText = "";
    let dialogTitle = "";
    let responses = "";
    for (let i=lastIndx; i<nbrDialogItems && selectDialog === false; i++){
         let checkDialogObj = dialogTable[i];  
         dialogTitle = checkDialogObj.title;
         dialogText = checkDialogObj.text; 
         if (checkDialogObj.conditionList && checkDialogObj.conditionList.length > 0){
               selectDialog = checkDialogConditions (checkDialogObj.conditionList, dialogPlayerConditions);
         }else{
               lastIndx = i; 
               selectDialog = true;
         }
         if (selectDialog === true){
            responses = checkDialogObj.responses;
         }
    }

    if (selectDialog === true){
        returnDialogObj = {title: dialogTitle, text: dialogText, responses: responses, 
            dialogIndx: lastIndx, nbrDialogItems: nbrDialogItems};
    }else{
        returnDialogObj = {text: "", responses: [], dialogIndx: 0};
    }
  
    return returnDialogObj;
   
}
export default retrieveGameDialog;

